import React from 'react'

const ContactMain = () => {
  return (
    <div id='website-responsive' className=''>
        <div className='bg-img' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/Contact-Us-Banner-v1.1.png")', height:'100%', width:'100%'}}>
            <div className='toxicology-text-padding'>
                <div className='-max-width display-none'>
                    <text className='fs-ss-52 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px', textShadow:'2px 2px 6px rgba(0,0,0,.25)'}}>
                    CONTACT US
                    </text>
                </div>

                <div className='-max-width display-block1'>
                    <text className='fs-ss-16 text-montserrat fw-600 lh-1 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                        CONTACT US
                    </text>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ContactMain